export default Schema => {
  const name = Schema.name.toUpperCase();

  const types = {
    INSERT: `@@acast-resource/INSERT_${name}`,
    PREPEND: `@@acast-resource/PREPEND_${name}`,
    APPEND: `@@acast-resource/APPEND_${name}`,
    REMOVE: `@@acast-resource/REMOVE_${name}`,
  };

  const creators = {
    insert: (key, data) => dispatch => {
      dispatch({
        type: types.INSERT,
        key,
        data,
      });
    },

    prepend: (key, data) => dispatch => {
      dispatch({
        type: types.PREPEND,
        key,
        data,
      });
    },

    append: (key, data) => dispatch => {
      dispatch({
        type: types.APPEND,
        key,
        data,
      });
    },

    remove: (key, data) => dispatch => {
      dispatch({
        type: types.REMOVE,
        key,
        data,
      });
    },
  };

  return {
    ...types,
    ...creators,
  };
};
